module.exports = __webpack_public_path__ + "static/media/User_3@3x.1636e966.png";